import * as angular from "angular";
import {LoadingService} from "./loading.service";

export const LoadingModule = angular
    .module("app.shared.loading", [])

    .service("loadingService", LoadingService)

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/loading/loading.module.ts